import * as React from 'react';
import {
    CategoryColorValue,
    CategoryType,
    getCategoryColorsForCategory,
    getMasterCategoryList,
} from 'owa-categories';
import { computed } from 'mobx';
import { logUsage } from 'owa-analytics';
import { observer } from 'mobx-react';

const styles = require('./Category.scss');
const classNames = require('classnames/bind').bind(styles);

export interface CategoryProps {
    category: string;
    categoryList?: CategoryType[];
    actionSource: string;
    isLastInWell: boolean;
    containerClassName?: string;
    onCategoryClicked?: (
        ev: React.MouseEvent<unknown>,
        category: string,
        actionSource: string
    ) => void;
}

@observer
export default class Category extends React.Component<CategoryProps, {}> {
    private categoryContainerElement: HTMLElement;

    @computed
    get categoryColor(): CategoryColorValue {
        return getCategoryColorsForCategory(
            this.props.category,
            this.props.categoryList ? this.props.categoryList : getMasterCategoryList()
        );
    }

    render() {
        const cStyle = {
            backgroundColor: this.categoryColor.primaryColor,
            borderColor: this.categoryColor.secondaryColor,
            color: this.categoryColor.textColor,
            cursor: this.props.onCategoryClicked ? 'pointer' : 'initial',
        };

        const categoryName = this.props.category;
        const containerClassnames = classNames(
            this.props.containerClassName,
            this.props.isLastInWell ? styles.lastCategoryContainer : styles.categoryContainer
        );

        return (
            <div
                ref={r => (this.categoryContainerElement = r)}
                key={categoryName}
                className={containerClassnames}
                style={cStyle}
                title={categoryName}
                onMouseEnter={this.onMouseEnterCategory}
                onMouseLeave={this.onMouseLeaveCategory}
                onClick={this.onCategoryClicked}>
                <span className={styles.categoryName}>{categoryName}</span>
            </div>
        );
    }

    private onCategoryClicked = (ev: React.MouseEvent<unknown>) => {
        if (this.props.onCategoryClicked) {
            logUsage('Category_Well_Click', [this.props.actionSource]);
            this.props.onCategoryClicked(ev, this.props.category, this.props.actionSource);
        }
    };

    private onMouseEnterCategory = () => {
        if (this.props.onCategoryClicked) {
            this.categoryContainerElement.style.borderColor = this.categoryColor.textColor;
        }
    };

    private onMouseLeaveCategory = () => {
        if (this.props.onCategoryClicked) {
            this.categoryContainerElement.style.borderColor = this.categoryColor.secondaryColor;
        }
    };
}
